import * as React from 'react';
import { clsx } from 'clsx';

type Props = React.ComponentPropsWithoutRef<"span"> & {
	className?: string,
	iconClassName?: string
}

/*
	Close/dismiss control. Draws its own X as an inline SVG rather than a Font
	Awesome glyph — the project ships no icon font, so the old `icon-times` class
	rendered nothing and the control was invisible in every dialog.
*/
function DeleteButton({className = '', iconClassName = '', onClick, ...otherProps}: Props) {
	return (
		<span
			role="button"
			tabIndex={0}
			aria-label="Close"
			onClick={onClick}
			onKeyDown={(event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					event.currentTarget.click();
				}
			}}
			className={clsx(className, "inline-flex cursor-pointer leading-none text-black hover:text-rose-600")}
			{...otherProps}
		>
			<svg
				className={clsx(iconClassName, "w-6 h-6")}
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				aria-hidden="true"
			>
				<path d="M6 6L18 18M18 6L6 18"/>
			</svg>
		</span>
	);
}

export default DeleteButton;
